import api from "../../services/api.js";
import { useEffect, useState } from "react";
import "../fornecedores-catalogos-storage/fornecedores-catalogos-storage.css"

import { Link } from "react-router-dom";

function FornecedoresCatalogosStorage() {

    const [dados, setDados] = useState([]);
    const [url_doc_forn, setUrl_doc_forn] = useState("");
    const [id_fornecedor, setId_fornecedor] = useState(0);
    const [nome_fornecedor, setNome_fornecedor] = useState("");

    function PesquisarUrlCatalogo() {//pesquisa catalogos ao iniciar conforme id fornecedor no storage local

        let id_fornecedor = localStorage.getItem('id_fornecedor');
      
        api.get("/fornecedores_doc_url", { params: { id_fornecedor } })
          .then((resp) => {
            setDados(resp.data);
           //console.log(resp.data)
          })
          .catch((err) => {
            setDados([]);
            alert("Erro ao carregar dados");
          });
      }

    function ChangeUrl(e) {
        setUrl_doc_forn(e.target.value);
    }

    useEffect(() => {
        setId_fornecedor(localStorage.getItem('id_fornecedor'));
        setNome_fornecedor(localStorage.getItem('nome_fornecedor'));
        PesquisarUrlCatalogo();
    }, []);

    return <>
        <div className="d-flex justify-content-center container-fundo-fran-cont">
            <div className="d-inline justify-content-center  container-body-fran-cont">

                <div className="d-flex justify-content-between mt-2">
                    <div className=" col-6 ms-4">
                        <input type="text" className="form-control" value={id_fornecedor + " - " + nome_fornecedor} />
                    </div>

                    <div className="col-3  mb-3">
                        <select className="form-control select-url " name="url" id="url" onChange={ChangeUrl}>
                            <option value="">Selecione</option>
                            {
                                dados.map((item) => {
                                    return<option key={item.id_doc_fornecedor} value={item.url_doc_forn}>{item.descr_doc}</option>
                                })
                            }
                        </select>
                    </div>

                 <div>
                     <Link to="/fornecedores" className="btn btn-success p-2 me-5 btn-sm" >Voltar </Link>

                 </div>
                       
                   
                </div>

                <div className="d-flex justify-content-center  overflow-auto">
                    <div className="  d-block">
                        <div className=" col-11">
                            <div className="">
                                <iframe className=" col-11 frame-contratos-franquias ms-4 " src={url_doc_forn}></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    </>
}
export default FornecedoresCatalogosStorage;